import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./CoachProfile.scss";
import ApiURL from "../../services/ApiURL";
import {
  CoachProfileApi,
  getActivitiesForCategory,
} from "../../services/CallApi";
import CoachProfileTile from "../../components/ReusableComponents/CoachProfileBox/CoachProfileTile/CoachProfileTile";
import { selectIcon, SVG } from "../../components/UI/selector";
import { OndemandHocCarousel } from "../../components/ReusableComponents/VideoUI/VideoUI";
import { ClassHocCarousel } from "../../components/ReusableComponents/LiveClassTile/ClassBox/ClassBox";
import { useSelector } from "react-redux";
import { ErrorUI } from "../../components/UI/Modals/Modals";
import CategoryProfileBox from "../../components/ReusableComponents/CategoryProfileBox/CategoryProfileBox";

const CoachProfile = ({ isCategory, ...props }) => {
  const params = useParams();
  const { defaultGym } = useSelector((state) => state.profile.profileData);
  const [coachProfileData, UpdateCoachProfileData] = useState({
    user_id: null,
    first_name: "-",
    last_name: "-",
    number_of_ondemand_videos_published: 0,
    number_of_upcoming_activities: 0,
    profile_pic_thumb: selectIcon("userDummy"),
    profile_pic_original: selectIcon("userDummy"),
    live_Upcoming_activities_list: null,
    ondemand_activities_list: [],
  });
  const [category, setCategory] = useState({
    category_name: "-",
    category_image_original: selectIcon("userDummy"),
    is_icon_selected: true,
  });

  useEffect(() => {
    if (defaultGym) {
      if (isCategory) {
        getCategoryProfileData();
      } else {
        getCoachProfileData();
      }
    }
  }, [defaultGym]);

  const getCoachProfileData = () => {
    const payload = {
      offset: 0,
      limit: 100,
      coach_id: params.id,
      gym_ids: JSON.stringify([defaultGym.gym_id]),
    };
    CoachProfileApi(ApiURL._coachProfileData, payload).then(async (res) => {
      if (res.status) {
        UpdateCoachProfileData({ ...res.list });
      } else {
        ErrorUI(res.list, () => {
          getCoachProfileData();
        });
      }
    });
  };

  const getCategoryProfileData = () => {
    const payload = {
      offset: 0,
      limit: 100,
      category_id: params.id,
      gym_id: defaultGym.gym_id,
      section_name: JSON.stringify(["live_and_upcoming", "ondemand_classes"]),
    };
    getActivitiesForCategory(ApiURL._listActivitesForCategory, payload).then(
      async (res) => {
        if (res.status) {
          console.info(res.list);
          UpdateCoachProfileData({
            number_of_ondemand_videos_published: res.list.total_ondemand_count,
            number_of_upcoming_activities: res.list.total_schedule_count,
            live_Upcoming_activities_list: res.list.live_and_upcoming,
            ondemand_activities_list: res.list.ondemand_classes,
          });
          setCategory(res.list.category_info);
        } else {
          ErrorUI(res.list, () => {
            getCategoryProfileData();
          });
        }
      }
    );
  };

  const {
    ondemand_activities_list,
    live_Upcoming_activities_list,
    number_of_ondemand_videos_published,
    number_of_upcoming_activities,
  } = coachProfileData;

  const { category_name, category_image_original, is_icon_selected } = category;

  return coachProfileData.live_Upcoming_activities_list ? (
    <div className="CoachProfile">
      <div className="CoachProfileHeaderSection">
        {isCategory ? (
          <CategoryProfileBox
            id={params.id}
            name={category_name}
            icon={category_image_original}
            full={!is_icon_selected}
          />
        ) : (
          <CoachProfileTile show_last_name={true} {...coachProfileData} />
        )}
        <div className="CoachProfileStatsRow">
          <div className="CoachProfileStats">
            <div className="CoachProfileStatsIconDiv">
              <SVG src={selectIcon("cameraIcon1")} />
            </div>
            <div className="CoachProfileStatsData">
              <p>{number_of_upcoming_activities}</p>
              <p>Upcoming</p>
            </div>
          </div>
          <div className="CoachProfileStats">
            <div className="CoachProfileStatsIconDiv">
              <SVG src={selectIcon("playIcon1")} />
            </div>
            <div className="CoachProfileStatsData">
              <p>{number_of_ondemand_videos_published}</p>
              <p>Ondemand</p>
            </div>
          </div>
        </div>
      </div>
      <ClassHocCarousel
        heading="LIVE & UPCOMING CLASSES"
        shouldHitApi={false}
        apiData={live_Upcoming_activities_list}
        zeroStateText="No Upcoming classes at the moment."
      />
      <OndemandHocCarousel
        heading="ONDEMAND CLASSES"
        shouldHitApi={false}
        apiData={ondemand_activities_list}
        zeroStateText="No Ondemand classes."
      />
    </div>
  ) : null;
};

export default CoachProfile;
